export function escapeHtmlUtil(text: string): string {
  if (typeof text !== 'string') {
    text = text == null ? '' : String(text);
  }

  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>');
}
